var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWalletPayout = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#walletPayout_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  d: "M5.455 6.712h1V.998H8.09v5.714h5.455v1.81H8.09v5.714H6.455V8.522H1v-1.81zm10.909 5.715h1V6.712h17.181c.684 0 1.35.284 1.848.807.5.523.789 1.243.789 2.003v.905H21.818a4.56 4.56 0 0 0-3.295 1.425 4.9 4.9 0 0 0-1.341 3.384v15.238c0 1.261.478 2.48 1.342 3.384a4.56 4.56 0 0 0 3.294 1.426h15.364v.904c0 1.607-1.214 2.81-2.637 2.81H9.091c-.684 0-1.35-.284-1.848-.806a2.9 2.9 0 0 1-.788-2.004V18.141h5.454v-5.714zM39 29.474H22.818V16.236H39zm-6.182-6.619c0-2.089-1.622-3.857-3.727-3.857s-3.727 1.768-3.727 3.857 1.622 3.857 3.727 3.857 3.727-1.768 3.727-3.857Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "walletPayout_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
})))));
export default SvgWalletPayout;